export enum ThingPendingChangeType {
  IP_ADDRESS = 'IP_ADDRESS',
  NETMASK = 'NETMASK',
  UNIT = 'UNIT',
  SMS_NUMBER = 'SMS_NUMBER',
}
